import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('employee');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await register(email, password, name, role);
    setLoading(false);

    if (result.success) {
      toast.success('Registrering lyckades!');
      navigate('/dashboard');
    } else {
      toast.error(result.error || 'Registrering misslyckades');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-muted">
      <Card className="w-full max-w-md" data-testid="register-card">
        <CardHeader className="text-center">
          <div className="mb-4">
            <h1 className="text-4xl font-heading font-black text-primary tracking-tight">AIUS</h1>
            <p className="text-sm text-muted-foreground mt-1">Growth Tracker</p>
          </div>
          <CardTitle className="text-2xl font-heading font-bold">Skapa konto</CardTitle>
          <CardDescription>Fyll i dina uppgifter för att komma igång</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="register-form">
            <div className="space-y-2">
              <Label htmlFor="name">Namn</Label>
              <Input
                id="name"
                data-testid="name-input"
                type="text"
                placeholder="Ditt namn"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="h-12"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">E-post</Label>
              <Input
                id="email"
                data-testid="email-input"
                type="email"
                placeholder="din@email.se"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="h-12"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Lösenord</Label>
              <Input
                id="password"
                data-testid="password-input"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="h-12"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="role">Roll</Label>
              <Select value={role} onValueChange={setRole}>
                <SelectTrigger data-testid="role-select" className="h-12">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="employee">Medarbetare</SelectItem>
                  <SelectItem value="customer_admin">Kundadmin</SelectItem>
                  <SelectItem value="read_only_assigner">Läsbehörighet (Uppdragsgivare)</SelectItem>
                  <SelectItem value="read_only_participant">Läsbehörighet (Deltagare)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <Button 
              data-testid="register-submit-btn"
              type="submit" 
              className="w-full h-12 text-lg font-bold rounded-full"
              disabled={loading}
            >
              {loading ? 'Registrerar...' : 'Skapa konto'}
            </Button>
          </form>
          <div className="mt-6 text-center text-sm">
            <p className="text-muted-foreground">
              Har du redan ett konto?{' '}
              <Link to="/login" className="text-primary font-bold hover:underline" data-testid="login-link">
                Logga in här
              </Link>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RegisterPage;
